import { sidebarToggledEvent } from '#pplx/frontend/apps/ask/events/sidebar/analytics.js';
import { useSidebarPinned } from '#pplx/frontend/apps/ask/layout/sidebar/core/shared/useSidebarPinned.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback } from 'react';
export function useSidebarToggleActions() {
    const [isSidebarPinned, setIsSidebarPinned] = useSidebarPinned();
    const { track } = useInstrumentation();
    const setSidebarPinned = useCallback((update) => {
        setIsSidebarPinned((currentValue) => {
            const nextValue = typeof update === 'function' ? update(currentValue) : update;
            if (nextValue === currentValue)
                return currentValue;
            track(sidebarToggledEvent({
                name: 'sidebar toggled',
                data: { is_collapsed: !nextValue },
            }));
            return nextValue;
        });
    }, [setIsSidebarPinned, track]);
    const toggleSidebar = useCallback(() => {
        setSidebarPinned((currentValue) => !currentValue);
    }, [setSidebarPinned]);
    const openSidebar = useCallback(() => {
        setSidebarPinned(true);
    }, [setSidebarPinned]);
    return { isSidebarPinned, setIsSidebarPinned: setSidebarPinned, toggleSidebar, openSidebar };
}
//# sourceMappingURL=useSidebarToggleActions.js.map